

































import { bookGoodsModelProvider } from '../model'
import { computed } from '@vue/composition-api'
import { defineClassComponent } from '@/hooks'

export default defineClassComponent(
  () =>
    class {
      bookGoodsModel = bookGoodsModelProvider.inject()

      // 营销数据
      marketingData = computed(() => this.bookGoodsModel.value.marketingData)
    },
)
